import { Component, OnInit } from '@angular/core';
import { CiacService } from 'src/app/services/http/ciac.service';
import { Router } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';

@Component({
  selector: 'app-lista-consultas-fornecedores',
  templateUrl: './lista-consultas-fornecedores.component.html',
  styleUrls: ['./lista-consultas-fornecedores.component.scss']
})
export class ListaConsultasFornecedoresComponent implements OnInit {

  sorting: { 
    id: "asc",
  }

  filter = {
    sorting: { 
      id: "asc",
    },
    filter: {
      consulta: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  listaRegistros = [];

  total = 0;
  tableLoading = false;

  constructor(private ciacService: CiacService, private router: Router, private modalMsgService: ModalMsgService, private modalService: NgbModal) { }

  ngOnInit() {
    this.getListagemDados();
  }

  getListagemDados() {
    this.filter.sorting = this.removeEmpty({ ...this.sorting });
    let dataUpdate = this.filter.data;
    this.ciacService.getListaFornecedoresConsultas(this.filter).then(c => {
      if(dataUpdate == this.filter.data) {
        this.tableLoading = false;
        this.total = c.total || 0;
        this.listaRegistros = this.listaRegistros.concat(c.lista) || [];
      }
    });
    if(this.listaRegistros.length == 0) {
      this.tableLoading = false;
    }
  }

  removeEmpty(obj) {
    this.listaRegistros = [];
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getListagemDados();
  }

  nextPage() {
    this.getListagemDados();
  }

  editRegistro(id) {
    this.router.navigate(['ciac', 'consultas-fornecedores', 'editar', id ]);
  }

  addDadosConsultaEntrada(id) {
    this.router.navigate(['ciac', 'consultas-fornecedores', 'dados-consulta-entrada', id ]);
  }

  delRegistro(id) {
    let params = {
      id: parseInt(id)
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover Registro';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.ciacService.delConsultaFornecedor(justificativa, params)
          .then(r => this.getListagemDados())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover registro', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover registro',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover registro',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

}
